// <auto-generated />
// ATENCAO: Arquivo auto-gerado pelo SetupController. Nao altere manualmente.

export const GEO_PAISES = {
  Afeganistao: 'GEO_PAISES1',
  AfricaDoSul: 'GEO_PAISES2',
  Albania: 'GEO_PAISES3',
  Alemanha: 'GEO_PAISES4',
  Andorra: 'GEO_PAISES5',
  Angola: 'GEO_PAISES6',
  AntiguaEBarbuda: 'GEO_PAISES7',
  ArabiaSaudita: 'GEO_PAISES8',
  Argelia: 'GEO_PAISES9',
  Argentina: 'GEO_PAISES10',
  Armenia: 'GEO_PAISES11',
  Australia: 'GEO_PAISES12',
  Austria: 'GEO_PAISES13',
  Azerbaijao: 'GEO_PAISES14',
  Bahamas: 'GEO_PAISES15',
  Bahrein: 'GEO_PAISES16',
  Bangladesh: 'GEO_PAISES17',
  Barbados: 'GEO_PAISES18',
  Belgica: 'GEO_PAISES19',
  Belize: 'GEO_PAISES20',
  Benim: 'GEO_PAISES21',
  Bielorrussia: 'GEO_PAISES22',
  Bolivia: 'GEO_PAISES23',
  BosniaEHerzegovina: 'GEO_PAISES24',
  Botsuana: 'GEO_PAISES25',
  Brasil: 'GEO_PAISES26',
  Brunei: 'GEO_PAISES27',
  Bulgaria: 'GEO_PAISES28',
  BurquinaFaso: 'GEO_PAISES29',
  Burundi: 'GEO_PAISES30',
  Butao: 'GEO_PAISES31',
  CaboVerde: 'GEO_PAISES32',
  Camaroes: 'GEO_PAISES33',
  Camboja: 'GEO_PAISES34',
  Canada: 'GEO_PAISES35',
  Catar: 'GEO_PAISES36',
  Cazaquistao: 'GEO_PAISES37',
  Chade: 'GEO_PAISES38',
  Chile: 'GEO_PAISES39',
  China: 'GEO_PAISES40',
  Chipre: 'GEO_PAISES41',
  Colombia: 'GEO_PAISES42',
  Comores: 'GEO_PAISES43',
  Congobrazzaville: 'GEO_PAISES44',
  CoreiaDoNorte: 'GEO_PAISES45',
  CoreiaDoSul: 'GEO_PAISES46',
  CostaDoMarfim: 'GEO_PAISES47',
  CostaRica: 'GEO_PAISES48',
  Croacia: 'GEO_PAISES49',
  Cuba: 'GEO_PAISES50',
  Dinamarca: 'GEO_PAISES51',
  Djibuti: 'GEO_PAISES52',
  Dominica: 'GEO_PAISES53',
  Egito: 'GEO_PAISES54',
  ElSalvador: 'GEO_PAISES55',
  EmiradosArabesUnidos: 'GEO_PAISES56',
  Equador: 'GEO_PAISES57',
  Eritreia: 'GEO_PAISES58',
  Eslovaquia: 'GEO_PAISES59',
  Eslovenia: 'GEO_PAISES60',
  Espanha: 'GEO_PAISES61',
  Essuatini: 'GEO_PAISES62',
  EstadosUnidos: 'GEO_PAISES63',
  Estonia: 'GEO_PAISES64',
  Etiopia: 'GEO_PAISES65',
  Fiji: 'GEO_PAISES66',
  Filipinas: 'GEO_PAISES67',
  Finlandia: 'GEO_PAISES68',
  Franca: 'GEO_PAISES69',
  Gabao: 'GEO_PAISES70',
  Gambia: 'GEO_PAISES71',
  Gana: 'GEO_PAISES72',
  Georgia: 'GEO_PAISES73',
  Granada: 'GEO_PAISES74',
  Grecia: 'GEO_PAISES75',
  Guatemala: 'GEO_PAISES76',
  Guiana: 'GEO_PAISES77',
  Guine: 'GEO_PAISES78',
  Guinebissau: 'GEO_PAISES79',
  GuineEquatorial: 'GEO_PAISES80',
  Haiti: 'GEO_PAISES81',
  Honduras: 'GEO_PAISES82',
  Hungria: 'GEO_PAISES83',
  Iemen: 'GEO_PAISES84',
  IlhasMarshall: 'GEO_PAISES85',
  IlhasSalomao: 'GEO_PAISES86',
  India: 'GEO_PAISES87',
  Indonesia: 'GEO_PAISES88',
  Ira: 'GEO_PAISES89',
  Iraque: 'GEO_PAISES90',
  Irlanda: 'GEO_PAISES91',
  Islandia: 'GEO_PAISES92',
  Israel: 'GEO_PAISES93',
  Italia: 'GEO_PAISES94',
  Jamaica: 'GEO_PAISES95',
  Japao: 'GEO_PAISES96',
  Jordania: 'GEO_PAISES97',
  Kiribati: 'GEO_PAISES98',
  Kuwait: 'GEO_PAISES99',
  Laos: 'GEO_PAISES100',
  Lesoto: 'GEO_PAISES101',
  Letonia: 'GEO_PAISES102',
  Libano: 'GEO_PAISES103',
  Liberia: 'GEO_PAISES104',
  Libia: 'GEO_PAISES105',
  Liechtenstein: 'GEO_PAISES106',
  Lituania: 'GEO_PAISES107',
  Luxemburgo: 'GEO_PAISES108',
  MacedoniaDoNorte: 'GEO_PAISES109',
  Madagascar: 'GEO_PAISES110',
  Malasia: 'GEO_PAISES111',
  Malaui: 'GEO_PAISES112',
  Maldivas: 'GEO_PAISES113',
  Mali: 'GEO_PAISES114',
  Malta: 'GEO_PAISES115',
  Marrocos: 'GEO_PAISES116',
  Mauricio: 'GEO_PAISES117',
  Mauritania: 'GEO_PAISES118',
  Mexico: 'GEO_PAISES119',
  Micronesia: 'GEO_PAISES120',
  Mocambique: 'GEO_PAISES121',
  Moldavia: 'GEO_PAISES122',
  Monaco: 'GEO_PAISES123',
  Mongolia: 'GEO_PAISES124',
  Montenegro: 'GEO_PAISES125',
  Myanmar: 'GEO_PAISES126',
  Namibia: 'GEO_PAISES127',
  Nauru: 'GEO_PAISES128',
  Nepal: 'GEO_PAISES129',
  Nicaragua: 'GEO_PAISES130',
  Niger: 'GEO_PAISES131',
  Nigeria: 'GEO_PAISES132',
  Noruega: 'GEO_PAISES133',
  NovaZelandia: 'GEO_PAISES134',
  Oma: 'GEO_PAISES135',
  PaisesBaixos: 'GEO_PAISES136',
  Palau: 'GEO_PAISES137',
  Panama: 'GEO_PAISES138',
  PapuanovaGuine: 'GEO_PAISES139',
  Paquistao: 'GEO_PAISES140',
  Paraguai: 'GEO_PAISES141',
  Peru: 'GEO_PAISES142',
  Polonia: 'GEO_PAISES143',
  Portugal: 'GEO_PAISES144',
  Quenia: 'GEO_PAISES145',
  Quirguistao: 'GEO_PAISES146',
  ReinoUnido: 'GEO_PAISES147',
  RepublicaCentroafricana: 'GEO_PAISES148',
  RepublicaCheca: 'GEO_PAISES149',
  RepublicaDemocraticaDoCongo: 'GEO_PAISES150',
  RepublicaDominicana: 'GEO_PAISES151',
  Romenia: 'GEO_PAISES152',
  Ruanda: 'GEO_PAISES153',
  Russia: 'GEO_PAISES154',
  Samoa: 'GEO_PAISES155',
  SantaLucia: 'GEO_PAISES156',
  SaoCristovaoENeves: 'GEO_PAISES157',
  SaoMarinho: 'GEO_PAISES158',
  SaoTomeEPrincipe: 'GEO_PAISES159',
  SaoVicenteEGranadinas: 'GEO_PAISES160',
  Seicheles: 'GEO_PAISES161',
  Senegal: 'GEO_PAISES162',
  SerraLeoa: 'GEO_PAISES163',
  Servia: 'GEO_PAISES164',
  Singapura: 'GEO_PAISES165',
  Siria: 'GEO_PAISES166',
  Somalia: 'GEO_PAISES167',
  SriLanka: 'GEO_PAISES168',
  Sudao: 'GEO_PAISES169',
  SudaoDoSul: 'GEO_PAISES170',
  Suecia: 'GEO_PAISES171',
  Suica: 'GEO_PAISES172',
  Suriname: 'GEO_PAISES173',
  Tailandia: 'GEO_PAISES174',
  Taiwan: 'GEO_PAISES175',
  Tajiquistao: 'GEO_PAISES176',
  Tanzania: 'GEO_PAISES177',
  Timorleste: 'GEO_PAISES178',
  Togo: 'GEO_PAISES179',
  Tonga: 'GEO_PAISES180',
  TrindadeETobago: 'GEO_PAISES181',
  Tunisia: 'GEO_PAISES182',
  Turquemenistao: 'GEO_PAISES183',
  Turquia: 'GEO_PAISES184',
  Tuvalu: 'GEO_PAISES185',
  Ucrania: 'GEO_PAISES186',
  Uganda: 'GEO_PAISES187',
  Uruguai: 'GEO_PAISES188',
  Uzbequistao: 'GEO_PAISES189',
  Vanuatu: 'GEO_PAISES190',
  Vaticano: 'GEO_PAISES191',
  Venezuela: 'GEO_PAISES192',
  Vietna: 'GEO_PAISES193',
  Zambia: 'GEO_PAISES194',
  Zimbabue: 'GEO_PAISES195',
  // Mapa de sequencia (SequenciaLista) para lookup por codigo
  sequencia: {
    GEO_PAISES1: 1,
    GEO_PAISES2: 2,
    GEO_PAISES3: 3,
    GEO_PAISES4: 4,
    GEO_PAISES5: 5,
    GEO_PAISES6: 6,
    GEO_PAISES7: 7,
    GEO_PAISES8: 8,
    GEO_PAISES9: 9,
    GEO_PAISES10: 10,
    GEO_PAISES11: 11,
    GEO_PAISES12: 12,
    GEO_PAISES13: 13,
    GEO_PAISES14: 14,
    GEO_PAISES15: 15,
    GEO_PAISES16: 16,
    GEO_PAISES17: 17,
    GEO_PAISES18: 18,
    GEO_PAISES19: 19,
    GEO_PAISES20: 20,
    GEO_PAISES21: 21,
    GEO_PAISES22: 22,
    GEO_PAISES23: 23,
    GEO_PAISES24: 24,
    GEO_PAISES25: 25,
    GEO_PAISES26: 26,
    GEO_PAISES27: 27,
    GEO_PAISES28: 28,
    GEO_PAISES29: 29,
    GEO_PAISES30: 30,
    GEO_PAISES31: 31,
    GEO_PAISES32: 32,
    GEO_PAISES33: 33,
    GEO_PAISES34: 34,
    GEO_PAISES35: 35,
    GEO_PAISES36: 36,
    GEO_PAISES37: 37,
    GEO_PAISES38: 38,
    GEO_PAISES39: 39,
    GEO_PAISES40: 40,
    GEO_PAISES41: 41,
    GEO_PAISES42: 42,
    GEO_PAISES43: 43,
    GEO_PAISES44: 44,
    GEO_PAISES45: 45,
    GEO_PAISES46: 46,
    GEO_PAISES47: 47,
    GEO_PAISES48: 48,
    GEO_PAISES49: 49,
    GEO_PAISES50: 50,
    GEO_PAISES51: 51,
    GEO_PAISES52: 52,
    GEO_PAISES53: 53,
    GEO_PAISES54: 54,
    GEO_PAISES55: 55,
    GEO_PAISES56: 56,
    GEO_PAISES57: 57,
    GEO_PAISES58: 58,
    GEO_PAISES59: 59,
    GEO_PAISES60: 60,
    GEO_PAISES61: 61,
    GEO_PAISES62: 62,
    GEO_PAISES63: 63,
    GEO_PAISES64: 64,
    GEO_PAISES65: 65,
    GEO_PAISES66: 66,
    GEO_PAISES67: 67,
    GEO_PAISES68: 68,
    GEO_PAISES69: 69,
    GEO_PAISES70: 70,
    GEO_PAISES71: 71,
    GEO_PAISES72: 72,
    GEO_PAISES73: 73,
    GEO_PAISES74: 74,
    GEO_PAISES75: 75,
    GEO_PAISES76: 76,
    GEO_PAISES77: 77,
    GEO_PAISES78: 78,
    GEO_PAISES79: 79,
    GEO_PAISES80: 80,
    GEO_PAISES81: 81,
    GEO_PAISES82: 82,
    GEO_PAISES83: 83,
    GEO_PAISES84: 84,
    GEO_PAISES85: 85,
    GEO_PAISES86: 86,
    GEO_PAISES87: 87,
    GEO_PAISES88: 88,
    GEO_PAISES89: 89,
    GEO_PAISES90: 90,
    GEO_PAISES91: 91,
    GEO_PAISES92: 92,
    GEO_PAISES93: 93,
    GEO_PAISES94: 94,
    GEO_PAISES95: 95,
    GEO_PAISES96: 96,
    GEO_PAISES97: 97,
    GEO_PAISES98: 98,
    GEO_PAISES99: 99,
    GEO_PAISES100: 100,
    GEO_PAISES101: 101,
    GEO_PAISES102: 102,
    GEO_PAISES103: 103,
    GEO_PAISES104: 104,
    GEO_PAISES105: 105,
    GEO_PAISES106: 106,
    GEO_PAISES107: 107,
    GEO_PAISES108: 108,
    GEO_PAISES109: 109,
    GEO_PAISES110: 110,
    GEO_PAISES111: 111,
    GEO_PAISES112: 112,
    GEO_PAISES113: 113,
    GEO_PAISES114: 114,
    GEO_PAISES115: 115,
    GEO_PAISES116: 116,
    GEO_PAISES117: 117,
    GEO_PAISES118: 118,
    GEO_PAISES119: 119,
    GEO_PAISES120: 120,
    GEO_PAISES121: 121,
    GEO_PAISES122: 122,
    GEO_PAISES123: 123,
    GEO_PAISES124: 124,
    GEO_PAISES125: 125,
    GEO_PAISES126: 126,
    GEO_PAISES127: 127,
    GEO_PAISES128: 128,
    GEO_PAISES129: 129,
    GEO_PAISES130: 130,
    GEO_PAISES131: 131,
    GEO_PAISES132: 132,
    GEO_PAISES133: 133,
    GEO_PAISES134: 134,
    GEO_PAISES135: 135,
    GEO_PAISES136: 136,
    GEO_PAISES137: 137,
    GEO_PAISES138: 138,
    GEO_PAISES139: 139,
    GEO_PAISES140: 140,
    GEO_PAISES141: 141,
    GEO_PAISES142: 142,
    GEO_PAISES143: 143,
    GEO_PAISES144: 144,
    GEO_PAISES145: 145,
    GEO_PAISES146: 146,
    GEO_PAISES147: 147,
    GEO_PAISES148: 148,
    GEO_PAISES149: 149,
    GEO_PAISES150: 150,
    GEO_PAISES151: 151,
    GEO_PAISES152: 152,
    GEO_PAISES153: 153,
    GEO_PAISES154: 154,
    GEO_PAISES155: 155,
    GEO_PAISES156: 156,
    GEO_PAISES157: 157,
    GEO_PAISES158: 158,
    GEO_PAISES159: 159,
    GEO_PAISES160: 160,
    GEO_PAISES161: 161,
    GEO_PAISES162: 162,
    GEO_PAISES163: 163,
    GEO_PAISES164: 164,
    GEO_PAISES165: 165,
    GEO_PAISES166: 166,
    GEO_PAISES167: 167,
    GEO_PAISES168: 168,
    GEO_PAISES169: 169,
    GEO_PAISES170: 170,
    GEO_PAISES171: 171,
    GEO_PAISES172: 172,
    GEO_PAISES173: 173,
    GEO_PAISES174: 174,
    GEO_PAISES175: 175,
    GEO_PAISES176: 176,
    GEO_PAISES177: 177,
    GEO_PAISES178: 178,
    GEO_PAISES179: 179,
    GEO_PAISES180: 180,
    GEO_PAISES181: 181,
    GEO_PAISES182: 182,
    GEO_PAISES183: 183,
    GEO_PAISES184: 184,
    GEO_PAISES185: 185,
    GEO_PAISES186: 186,
    GEO_PAISES187: 187,
    GEO_PAISES188: 188,
    GEO_PAISES189: 189,
    GEO_PAISES190: 190,
    GEO_PAISES191: 191,
    GEO_PAISES192: 192,
    GEO_PAISES193: 193,
    GEO_PAISES194: 194,
    GEO_PAISES195: 195
  }
}
